import React from "react";
import { Box } from "@mui/material";

// Template40: Página sobre Aeropuertos
// Copia DIRECTA del componente Airports.jsx de guia-kioto, adaptado para usar las props del sistema guia
const Template186 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const isSmallScreen = window.innerWidth <= 600;

	// Datos hardcodeados directamente en el componente
	const headerText = "Cómo llegar a Kioto desde los aeropuertos";
	const airportSticker = "/images/kyoto/kansai.png";

	// Lógica especial para la guía de Tokio: header #24221a en primera página, #e24217 en las siguientes
	const pageOrder = page.order !== undefined ? page.order : (page.data?.order !== undefined ? page.data.order : -1);
	const isTokioGuide = headerBackgroundColor === "#24221a";
	const actualHeaderColor = isTokioGuide && pageOrder > 0 ? "#e24217" : (headerBackgroundColor || "#5ba374");

	// Textos
	const introText = "Kioto no tiene aeropuerto propio. La mayoría llega a través de Osaka, donde se encuentran los aeropuertos de Kansai y Itami.";
	const kansaiTitle = "Aeropuerto de Kansai (KIX)";
	const kansaiText1 = "Tren Haruka Express: Llega directo a Kioto en aprox. 75 min (~2.200¥).";
	const kansaiText2 = "Airport Limousine Bus: Servicio directo a la estación de Kioto (~2.800¥, 1h30).";
	const kansaiText3 = "Taxi o traslado privado: Tarda unas 2h.";
	const infoText = "El Aeropuerto Internacional de Kansai (KIX) es el principal para vuelos internacionales y el Aeropuerto de Itami (ITM) opera sobre todo vuelos nacionales.";
	const itamiTitle = "Aeropuerto de Itami (ITM)";
	const itamiText1 = "Bus directo: 55 minutos hasta la estación de Kioto (~1.500¥).";
	const itamiText2 = "Taxi o traslado privado: Unos 60–70 minutos.";
	const itamiText3 = "Tren: Opción menos práctica, con trasbordos en Umeda o Shin-Osaka.";
	const harukaText = "El Haruka Express está incluido en el Japan Rail Pass, así que si lo tienes, el trayecto hasta Kioto es gratis.";
	const consejoTitle = "Consejo";
	const consejoText = "El Haruka Express sale directamente del aeropuerto de Kansai cada 30 minutos y llega a la estación de Kioto sin cambios.";

	// Estilos
	const box = {
		backgroundColor: "#e0f2e8",
		border: "3px solid #5ba374",
		borderRadius: "16px",
		padding: "16px",
	};

	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: 8,
		color: "#3d805e",
	};

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	const ul = {
		paddingLeft: 18,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
			height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
				"& p": {
					marginTop: "0px !important",
					marginBottom: "10px !important",
				},
			}}
		>
			{/* CABECERA */}
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 800,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1053,
				}}
			>
				{headerText}
			</Box>

			{/* INTRO */}
			<Box data-block-id="text-1" sx={{ padding: "12px 16px", fontSize: "13px", color: "#444" }}>
				<Box component="p" sx={{ ...p, margin: "0 !important", marginBottom: "0px !important" }}>
					{introText}
				</Box>
			</Box>

			{/* BLOQUES */}
			<Box
				data-block-id="text-2"
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: "16px",
					position: "relative",
					marginTop: isSmallScreen ? "20px" : 0,
				}}
			>
				<Box data-block-id="text-3" sx={box}>
					<Box component="h3" sx={{ ...h3, marginTop: 0 }}>
						{kansaiTitle}
					</Box>
					<Box component="ul" sx={ul}>
						<Box component="li" sx={{ ...p, margin: "0 !important", marginBottom: "4px !important" }}>
							<Box component="strong">{kansaiText1}</Box>
						</Box>
						<Box component="li" sx={{ ...p, margin: "0 !important", marginBottom: "4px !important" }}>
							<Box component="strong">{kansaiText2}</Box>
						</Box>
						<Box component="li" sx={{ ...p, margin: "0 !important", marginBottom: "0px !important" }}>
							<Box component="strong">{kansaiText3}</Box>
						</Box>
					</Box>
				</Box>

				<Box
					data-block-id="text-4"
					sx={{
						backgroundColor: "#fff8db",
						border: "2px solid #f5c400",
						borderRadius: "12px",
						padding: "12px 14px",
						fontSize: "12px",
						marginTop: "10px",
					}}
				>
					<Box component="b">{infoText}</Box>
				</Box>

				<Box data-block-id="text-5" sx={box}>
					<Box component="h3" sx={{ ...h3, marginTop: 0 }}>
						{itamiTitle}
					</Box>
					<Box component="ul" sx={ul}>
						<Box component="li" sx={{ ...p, margin: "0 !important", marginBottom: "4px !important" }}>
							<Box component="strong">{itamiText1}</Box>
						</Box>
						<Box component="li" sx={{ ...p, margin: "0 !important", marginBottom: "4px !important" }}>
							<Box component="strong">{itamiText2}</Box>
						</Box>
						<Box component="li" sx={{ ...p, margin: "0 !important", marginBottom: "0px !important" }}>
							<Box component="strong">{itamiText3}</Box>
						</Box>
					</Box>
				</Box>

				{/* SABÍAS QUE */}
				<Box
					data-block-id="text-6"
					sx={{
						backgroundColor: "#fff8db",
						border: "2px solid #f5c400",
						borderRadius: "12px",
						padding: "12px 14px",
						fontSize: "12px",
						marginTop: "10px",
					}}
				>
					{harukaText}
				</Box>

				{/* Stickers */}
				<Box
					component="img"
					src={airportSticker}
					alt="Kansai Sticker"
					sx={{
						width: isSmallScreen ? 90 : 100,
						position: "absolute",
						top: isSmallScreen ? "-40px" : "100px",
						right: isSmallScreen ? "-20px" : "-10px",
					}}
				/>

				{/* Consejo */}
				<Box
					data-block-id="text-7"
					sx={{
						backgroundColor: "#d9e6de",
						border: "3px solid #5ba374",
						borderRadius: "16px",
						padding: "16px",
						fontSize: "12px",
						color: "#444",
					}}
				>
					<Box
						component="h4"
						sx={{
							marginTop: 0,
							marginBottom: "8px",
							fontSize: "13px",
							color: "#5ba374",
							fontWeight: 700,
							textTransform: "uppercase",
						}}
					>
						{consejoTitle}
					</Box>
					<Box component="p" sx={{ ...p, margin: "0 !important", marginBottom: "0px !important" }}>
						{consejoText}
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

Template186.thumbnail = "/images/template-1.png";

export default Template186;

